export const topNavLinks = [
    { id: "services", label: "Services", hasMenu: false, badge: "11", to: "/services" },
    { id: "case-studies", label: "Portfolio", hasMenu: false, badge: "100+", to: "/portfolio" },
    { id: "blogs", label: "Blogs", hasMenu: false, to: "/blog" },
    { id: "about", label: "About", hasMenu: false, to: "/about" },
];

export const servicesMegaColumns = [
    {
        title: "Design",
        links: [
            { label: "UIUX Design", to: "/services/ui-ux" },
            { label: "Visual Identity", to: "/services/visual-identity" },
            { label: "Web Design", to: "/services/web-design" },
            { label: "Branding", to: "/services/visual-identity" },
            // Hidden until the /new-services/* pages ship — these /services/* URLs
            // have no route in App.jsx and 404 today. Restore when the pages go live.
            // { label: "Packaging Design", to: "/services/packaging-design" },
            { label: "3D Rendering", to: "/new-services/3d-rendering" },
            { label: "Motion Graphics", to: "/new-services/motion-graphics" },
        ],
    },
    {
        title: "E-commerce",
        links: [
            // Hidden until the /new-services/* pages ship — these /services/* URLs
            // have no route in App.jsx and 404 today. Restore when the pages go live.
            // { label: "Shopify Development", to: "/services/shopify-development" },
            // { label: "Shopify Plus Development", to: "/services/shopify-plus-development" },
            // { label: "Shopify Migration", to: "/services/shopify-migration" },
            { label: "Shopify App Development", to: "/services/shopify" },
            { label: "Shopify Store Audit", to: "/services/shopify" },
            // { label: "Headless Commerce", to: "/services/headless-commerce" },
            // { label: "Store Performance", to: "/services/store-performance" },
            // { label: "CRO", to: "/services/cro" },
            { label: "A/B Testing", to: "/services/ab-testing" },
        ],
    },
    {
        title: "Development",
        links: [
            { label: "Web Development", to: "/services/web-development" },
            { label: "Webflow Development", to: "/services/web-development" },
            { label: "MVP Development", to: "/services/for-startup" },
            { label: "CMS Development", to: "/services/web-development" },
            { label: "Mobile App Development", to: "/services" },
            { label: "Web3 Development", to: "/services" },
        ],
    },
];

export const caseStudiesLinks = [
    { label: "All Case Studies", to: "/portfolio" },
    { label: "E-commerce", to: "/portfolio" },
    { label: "Branding", to: "/portfolio" },
    { label: "UI/UX", to: "/portfolio" },
];

export const megaLocations = [
    { label: "India" },
    { label: "USA" },
    { label: "Dubai" },
];

/** Short labels match Figma footer (9976-9118): IG Fb Db Be X Li */
export const megaSocialLinks = [
    { id: "instagram", label: "IG", href: "https://www.instagram.com/aboxagency/", ariaLabel: "Instagram" },
    { id: "facebook", label: "Fb", href: "https://www.facebook.com/profile.php?id=100094598875876", ariaLabel: "Facebook" },
    { id: "dribbble", label: "Db", href: "https://dribbble.com/aboxagency", ariaLabel: "Dribbble" },
    { id: "behance", label: "Be", href: "https://www.behance.net/aboxagency", ariaLabel: "Behance" },
    { id: "x", label: "X", href: "https://twitter.com/aBox_Agency", ariaLabel: "X" },
    { id: "linkedin", label: "Li", href: "https://www.linkedin.com/company/aboxagency/", ariaLabel: "LinkedIn" },
];